
import * as React from 'react';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { DropdownButtonItem } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { OverflowDropdownButton } from '../../uiComponents/input/Buttons';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { Konkurrence } from '../../models/Konkurrence';
import { KonkurrencestatusEnum } from '../../models/enums/KonkurrencestatusEnum';

function menuFormatter(cell: any, row: any, konkurrencer: Konkurrence[]) {
    let editLink = '/konkurrence/rediger/' + row.id;
    let tilmeldteLink = '/tilmeldte-hold/' + row.id;
    let indtastResultater = `/opgave-bedoemmelse/${row.id}`;
    let scoreboardKonfigurationLink = `/scoreboardkonfiguration/${row.id}`;
    let scoreboard = `/scoreboard/${row.id}`;

    let konkurrence = konkurrencer.find(k => k.id === row.id && 
        (k.status === KonkurrencestatusEnum.Offentlig || k.status === KonkurrencestatusEnum.Afviklet));

    if (konkurrence === undefined) {       
        return (
            <OverflowDropdownButton>
                <DropdownButtonItem href={editLink} text='Redigér' />
                <DropdownButtonItem href={tilmeldteLink} text='Tilmeldte hold' />
            </OverflowDropdownButton>
        );
    } else if (konkurrence.status === KonkurrencestatusEnum.Afviklet) {
        return (
            <OverflowDropdownButton>
                <DropdownButtonItem href={editLink} text='Redigér' />
                <DropdownButtonItem href={tilmeldteLink} text='Tilmeldte hold' />
                <DropdownButtonItem href={scoreboard} text='Vis scoreboard' />
            </OverflowDropdownButton>  
        );
    } else {
        return (
            <OverflowDropdownButton>                
                <DropdownButtonItem href={editLink} text='Redigér' />
                <DropdownButtonItem href={tilmeldteLink} text='Tilmeldte hold' />
                <DropdownButtonItem href={scoreboardKonfigurationLink} text='Scoreboardkonfiguration' />
                <DropdownButtonItem href={scoreboard} text='Vis scoreboard' />
                <DropdownButtonItem href={indtastResultater} text='Indtast resultater' />
            </OverflowDropdownButton>
        );
    }

}

function antalTilmeldteHoldFormatter(cell: any, row: any) {
    if (row.antalHoldPaaVenteliste > 0) {
        return row.antalTilmeldteHold + ' (' + row.antalHoldPaaVenteliste + ')';    
    }
    return row.antalTilmeldteHold;
}

export interface KonkurrenceTableProps {
    konkurrencer?: Konkurrence[];
    pagination?: boolean;
}

export function KonkurrenceTable(props: KonkurrenceTableProps) {    
    let konkurrencer: Konkurrence[] = [];

    if (props.konkurrencer !== undefined) {
        konkurrencer = props.konkurrencer;
    }

    return (
        <Table data={props.konkurrencer} pagination={props.pagination} emptyText='Ingen konkurrencer'>
            <TableHeaderColumn dataField='id' isKey={true} hidden={true} dataAlign='center' />
            <TableHeaderColumn dataField='startdato' className='first' columnClassName='first' dataFormat={TableFormatters.dateFormatter} dataSort={true}>Dato</TableHeaderColumn>
            <TableHeaderColumn dataField='titel' dataSort={true}>Titel</TableHeaderColumn>
            <TableHeaderColumn dataField='afviklingssted' dataSort={true}>Konkurrencested</TableHeaderColumn>
            <TableHeaderColumn dataField='antalTilmeldteHold' dataFormat={antalTilmeldteHoldFormatter} dataSort={true}>Tilmeldte hold</TableHeaderColumn>
            <TableHeaderColumn dataField='maxAntalHold' dataSort={true}>Max hold</TableHeaderColumn>            
            <TableHeaderColumn dataField='status' dataFormat={TableFormatters.getStatusText} dataSort={true}>Status</TableHeaderColumn>
            <TableHeaderColumn width='60' dataFormat={(cell: any, row: any) => menuFormatter(cell, row, konkurrencer)} className='table-menu' columnClassName='table-menu' />
        </Table>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceTable.tsx